import request from '@/utils/request'

export function getTree() {
    return request.get('/api/back/employmentEmploy/district/getTree')
        .then(response => response)
}